import DomainEntity from '@/models/DomainEntity'

export default class StrategyStuffs extends DomainEntity {
  static get collectionName() {
    return 'strategystuffs/'
  }

  static get parentKey() {
    return 'strategy'
  }

  static defaults() {
    return {
      buy: [],
      upgrade: {},
      sell: [],
    }
  }
}
